import { useEffect, useState } from "react";
import KioskHome from "@/pages/KioskHome";
import SchoolKioskHome from "@/pages/SchoolKioskHome";
import api from "@/lib/api";

export default function KioskRouter() {
  const [type, setType] = useState(null); // null | 'business' | 'school'

  useEffect(() => {
    api.get("/me/company")
      .then(({ data }) => setType(data.type || "business"))
      .catch(() => setType("business"));
  }, []);

  if (type === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div className="text-slate-500 font-display text-lg">Loading kiosk…</div>
      </div>
    );
  }

  if (type === "daycare") return <SchoolKioskHome daycare />;
  return type === "school" ? <SchoolKioskHome /> : <KioskHome />;
}
